import React, { useState, useEffect, useRef } from "react";
import { MultiSelect } from "../../components/MultiSelect";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { CardStyled } from "../../components/Card";
import { Label, DateField } from "./style/styledComponents";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useTheme, Grid } from "@material-ui/core";
import { Actions } from "../../core/redux/ducks/article";
import useLanguage from "../../hooks/useLanguage";

const today = new Date();
const defaultFilterParams = {
  regions: [],
  startdate: "",
  enddate: "",
  categories: [],
};

export const Filter = ({ filterChange, loading }) => {
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedArticleTypes, setSArticleTypes] = useState([]);
  const [filters, setFilters] = useState({ categories: [], regions: [] });
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filterParams, setFilterParams] = useState(defaultFilterParams);
  const didMountRef = useRef(false);
  const theme = useTheme();
  const { language } = useLanguage();
  const { translate } = language;

  useEffect(() => {
    if (didMountRef.current) filterChange(filterParams);
    else didMountRef.current = true;
  }, [filterParams]);

  const getFilter = async () => {
    const filters = await Actions.getFilter();
    const categories = filters.data.categories.map((category) => ({
      value: category.key,
      label: category.label,
    }));
    const regions = filters.data.regions.map((region) => ({
      value: region.key,
      label: region.label,
    }));

    setFilters({ categories, regions });
  };

  useEffect(() => {
    getFilter();
  }, []);

  function handleDateChange(event, picker) {
    var startDate = picker.startDate.format("YYYY-MM-DD");
    var endDate = picker.endDate.format("YYYY-MM-DD");
    setStartDate(startDate);
    setEndDate(endDate);
    setFilterParams({
      ...filterParams,
      startdate: startDate,
      enddate: endDate,
    });
  }

  const handleSourceTypesChange = (categories) => {
    setSArticleTypes(categories);
    filterParams.categories = categories;
    setFilterParams({ ...filterParams, categories });
  };

  const handleRegionChange = (regions) => {
    setSelectedRegions(regions);
    setFilterParams({ ...filterParams, regions });
  };

  function handleCancel() {
    setStartDate("");
    setEndDate("");
    setFilterParams({
      ...filterParams,
      startdate: "",
      enddate: "",
    });
  }

  // const cleanFilter = () => {
  //   handleCancel();
  //   setSelectedRegions([]);
  //   setSArticleTypes([]);
  // };

  return (
    <CardStyled theme={theme}>
      <Grid container>
        <Grid item lg={3}>
          <Label theme={theme}>{translate.date}</Label>
          <DateRangePicker
            onApply={handleDateChange}
            onCancel={handleCancel}
            initialSettings={{
              autoUpdateInput: false,
              locale: {
                cancelLabel: "Clear",
              },
              maxDate: today,
            }}
          >
            <DateField
              placeholder={translate.date_placeholder}
              type="text"
              name="datefilter"
              className="form-control sort hidden hasDatepicker"
              value={startDate && endDate ? startDate + " - " + endDate : ""}
              readOnly
              theme={theme}
            />
          </DateRangePicker>
        </Grid>
        <Grid item lg={4}>
          {filters.regions && (
            <MultiSelect
              label={translate.region}
              placeholder={translate.region_placeholder}
              selectedList={selectedRegions}
              optionList={filters.regions}
              onChange={(value) => handleRegionChange(value)}
            />
          )}
        </Grid>
        <Grid item lg={5}>
          {filters.categories && (
            <MultiSelect
              label={translate.source_type}
              placeholder={translate.category_placeholder}
              selectedList={selectedArticleTypes}
              optionList={filters.categories}
              onChange={(value) => handleSourceTypesChange(value)}
            />
          )}
        </Grid>
      </Grid>
    </CardStyled>
  );
};
